<template>
  <div class="col-md-10 mx-auto">
    <b-card class="border-0 shadow-sm">
      <b-row>
        <b-col md="2">
          <b-form-select
            v-model="selected"
            :options="releaseNote"
            class="mb-3"
            value-field="version"
            text-field="version"
          ></b-form-select>
        </b-col>
        <b-col class="text-right">
          <b-form-checkbox v-model="showBadge" name="check-button" switch>
            Show badges for new release.
          </b-form-checkbox>
        </b-col>
      </b-row>
      <div
        class="p-1 col-md-12 m-0"
        v-for="(data, index) in releaseNoteComputed"
        :key="index"
      >
        <p class="m-0 p-0">Version {{ data.version }}
            <b-badge v-b-tooltip.hover title="Software Upgrade Plan ID" variant="warning">{{data.supId}}</b-badge>
        </p>
        <p class="text-muted">{{ data.label }}</p>
        <h4 class="m-0 p-0">{{ data.updates.heading }}</h4>
        <p class="m-0 p-0 text-muted">Added on {{ data.releasedOn }}</p>
        <hr />
        <p style="color:gray" class="m-0 p-0">{{ data.updates.releaseNote }}</p>
        <ul
          class="my-3"
          v-for="(item, index) in data.updates.releaseNoteList"
          :key="index"
        >
          <li style="" class="m-0 p-0">
            {{ item.topic }}
          </li>
           <b-badge v-if="showBadge" :variant="item.variant ? item.variant : 'success'">
             <i :class="item.icon ? item.icon : ''"></i>
             {{ item.label }}</b-badge>
          <div class="my-4">
            <img v-if="item.image" width="50%" :src="item.image" alt="">
          </div>
        </ul>
      </div>
    </b-card>
  </div>
</template>

<script>
import releaseNote from "../Inventory/releaseNote.json";
export default {
  data() {
    return {
      releaseNote: releaseNote,
      selected: "",
      showBadge: true,
    };
  },
  created() {
    this.selected = releaseNote[0].version;
  },
  computed: {
    releaseNoteComputed() {
      return this.releaseNote.filter((x) => {
        return x.version == this.selected;
      });
    },
  },
};
</script>

<style scoped>
div {
  font-weight: 400;
}
</style>
